// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".pointer.no-image[data-v-3023693f]{display:flex;justify-content:center;align-items:center}.solution-spec[data-v-3023693f]{padding:0;background-color:#f8f8f8}.product-details[data-v-3023693f]{padding:5px 25px 25px}.product-image[data-v-3023693f]{border-bottom:1px solid #b3b3b3}.btn-green-full[data-v-3023693f],.btn-orange-full[data-v-3023693f]{padding:5px 0}", ""]);
// Exports
module.exports = exports;
